// Client Spending Tracker - Version Selector
import ClientSpendingTrackerV1 from './v1';
import ClientSpendingTrackerV2 from './v2';

// Default export - current version (v2)
export default ClientSpendingTrackerV2;

// Named exports for specific versions
export { ClientSpendingTrackerV1, ClientSpendingTrackerV2 };
export { default as v1 } from './v1';
export { default as v2 } from './v2';
